import {
  Activity,
  BookOpen,
  Boxes,
  ClipboardCheck,
  Download,
  Gift,
  GitCompare,
  GraduationCap,
  HeartPulse,
  Layers,
  Library,
  ListChecks,
  Microscope,
  Presentation,
  ScanLine,
  ShieldCheck,
  Sparkles,
  Star,
  Stethoscope,
  Syringe,
  Users,
  Wrench,
  type LucideIcon,
} from 'lucide-react'

export interface IncludedFeature {
  label: string
  icon: LucideIcon
  /** Headline features get a larger, highlighted card */
  featured?: boolean
}

export const everythingIncluded: IncludedFeature[] = [
  { label: '6 Professional Visual Training Volumes', icon: Library, featured: true },
  { label: 'Complete 6-IN-1 Training System', icon: Boxes, featured: true },
  { label: 'Ready-to-Teach Lessons', icon: Presentation, featured: true },
  { label: 'Nursing Fundamentals & Patient Care', icon: BookOpen },
  { label: 'Human Anatomy', icon: Microscope },
  { label: 'Health Assessment', icon: Stethoscope },
  { label: 'Clinical Examination', icon: ScanLine },
  { label: 'Nursing Procedures', icon: Wrench },
  { label: 'Dosage Calculations', icon: Layers },
  { label: 'Med-Surg Nursing', icon: Activity },
  { label: 'Medication Administration', icon: Syringe },
  { label: 'Emergency Care & Clinical Judgment', icon: HeartPulse },
  { label: 'Infection Control & Patient Safety', icon: ShieldCheck },
  { label: 'Simulation Scenarios', icon: Users },
  { label: '❌/✅ Comparisons', icon: GitCompare },
  { label: 'Competency Rubrics', icon: ClipboardCheck },
  { label: 'Drills & Quick Checks', icon: ListChecks },
  { label: 'Easy to Advanced Variants', icon: Star },
  { label: 'Instructor Resources', icon: GraduationCap },
  { label: '5 Exclusive Bonuses', icon: Gift, featured: true },
  { label: 'Teaching Cues', icon: Sparkles },
  { label: 'Lesson Plans', icon: Activity },
  { label: 'Immediate Digital Access', icon: Download },
]
